import { Button, Heading, Text, TextField } from '@react-spectrum/s2';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };
import { useState } from 'react';

import { AnimateIn } from '@/components/AnimateIn';

// Single-input entry point for adding a similar business. The user types a
// name or pastes a website; on submit the parent seeds a competitor and starts
// research. Purely presentational — all side effects live in the parent.
export function AddBusinessComposer({
	onSubmit,
	onCancel,
}: {
	onSubmit: (query: string) => void;
	onCancel: () => void;
}) {
	const [value, setValue] = useState('');
	const trimmed = value.trim();

	const submit = () => {
		if (trimmed) onSubmit(trimmed);
	};

	return (
		<AnimateIn delay={0}>
			<div className="glass-card-sm p-6">
				<div className="flex flex-col gap-4">
					<Heading
						level={3}
						styles={style({
							font: 'title',
							fontWeight: 'bold',
							fontSize: 'title-sm',
						})}
					>
						Add a similar business
					</Heading>
					<TextField
						label="Business name or website"
						description={
							<span style={{ fontStyle: 'italic' }}>
								Enter a name or paste their website — we&apos;ll research the
								rest
							</span>
						}
						value={value}
						onChange={setValue}
						autoFocus
						styles={style({ width: 'full' })}
						onKeyDown={(e) => {
							if (e.key === 'Enter') submit();
						}}
					/>
					<div className="flex justify-end gap-2">
						<Button variant="secondary" size="S" onPress={onCancel}>
							<Text>Cancel</Text>
						</Button>
						<Button
							variant="accent"
							size="S"
							isDisabled={!trimmed}
							onPress={submit}
						>
							<Text>Add</Text>
						</Button>
					</div>
				</div>
			</div>
		</AnimateIn>
	);
}
